// The non-production "emulate the app" switch (BL-2342): lets a desktop browser,
// and so the Notion QA Agent, exercise the phone app's offline mode on
// admin-dev, staging and a local dev server. It must be impossible to turn on in
// production, so the guard fails CLOSED: only a named non-production environment
// (or an unlabelled local dev server) admits it.

/** Query parameter that turns emulation on (`=1`) or off (`=0`) for this browser. */
export const NATIVE_APP_EMULATION_PARAM = 'emulate-native-app';

/** localStorage key that remembers the switch for this browser (UI state, rule #16). */
export const NATIVE_APP_EMULATION_STORAGE_KEY = 'auctogon:emulate-native-app';

/** Environments where the switch may be turned on. */
const EMULATION_ENVIRONMENTS = new Set(['local', 'dev', 'staging']);

/** Inputs to {@link isNativeAppEmulationAllowed}, read by the caller from its build env. */
export interface NativeAppEmulationEnv {
  /** `NEXT_PUBLIC_AUCTOGON_ENV`, baked per environment at build time (`prod` in production). */
  auctogonEnv: string | undefined;
  /** `NODE_ENV`: `development` only under `next dev`. */
  nodeEnv: string | undefined;
}

/**
 * Whether the "emulate the app" switch may be honoured in this build.
 *
 * - A labelled environment decides: `local`, `dev` and `staging` admit it;
 *   `prod` and any other label refuse it.
 * - An unlabelled build admits it only under `next dev`. An unlabelled
 *   production build refuses it, so a build that lost its label fails closed.
 *
 * @param env - the build's environment label and `NODE_ENV`.
 * @returns true only outside production.
 */
export function isNativeAppEmulationAllowed(env: NativeAppEmulationEnv): boolean {
  const label = env.auctogonEnv?.trim();
  if (label) return EMULATION_ENVIRONMENTS.has(label);
  return env.nodeEnv === 'development';
}
